// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_title__AUUYC {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.styles_content__KgATV{
    align-items: center !important;
    display: flex !important;
    flex-direction: column !important;
    gap: 1rem !important;
    padding-top: 1rem !important;
}

.styles_containerBtn__fH67i{
    display: flex !important;
    justify-content: space-between !important;
    width: 100% !important;
}

.styles_btnCancelar__bF4ZS{
  background: #fff !important;
  border: 1px solid #18316e !important;
  color: #18316e !important;
}

.styles_btnSalvar__erV1O{
  background: #18316e !important;
  border: 1px solid #18316e !important;
  color: #fff !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/PreviaINSS/ModalEditar/styles.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,iCAAiC;IACjC,oBAAoB;IACpB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":[".title {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.content{\n    align-items: center !important;\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 1rem !important;\n    padding-top: 1rem !important;\n}\n\n.containerBtn{\n    display: flex !important;\n    justify-content: space-between !important;\n    width: 100% !important;\n}\n\n.btnCancelar{\n  background: #fff !important;\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n}\n\n.btnSalvar{\n  background: #18316e !important;\n  border: 1px solid #18316e !important;\n  color: #fff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `styles_title__AUUYC`,
	"content": `styles_content__KgATV`,
	"containerBtn": `styles_containerBtn__fH67i`,
	"btnCancelar": `styles_btnCancelar__bF4ZS`,
	"btnSalvar": `styles_btnSalvar__erV1O`
};
export default ___CSS_LOADER_EXPORT___;
